/** Usuario del sistema. */
export interface Usuario {
  id: string;
  nombre: string;
  email: string;
  rolId: string;
  activo: boolean;
  createdAt: string;
  updatedAt: string;
}

/** Rol con permisos. */
export interface Rol {
  id: string;
  nombre: string;
  descripcion: string;
  permisos: string[];
}

/** Permiso (clave técnica). */
export interface PermisoDef {
  clave: string;
  nombre: string;
  modulo: string;
}

/** Parámetros generales del sistema. */
export interface ParametrosGenerales {
  nombreEmpresa: string;
  rut: string;
  diasAlertaEpp: number;
  diasAlertaVigilancia: number;
  notificacionesEmail: boolean;
  notificacionesPush: boolean;
  recordatorioInspecciones: boolean;
  maxIntentosLogin: number;
  bloqueoMinutos: number;
}

/** Opciones de personalización. */
export interface Personalizacion {
  tema: 'claro' | 'oscuro' | 'sistema';
  idioma: string;
  formatoFecha: string;
  zonaHoraria: string;
  filasPorPagina: number;
}

/** Lista de permisos por módulo (clave → nombre). */
export const PERMISOS_DEF: PermisoDef[] = [
  { clave: 'dashboard_ver', nombre: 'Ver dashboard', modulo: 'Dashboard' },
  { clave: 'peligros_ver', nombre: 'Ver peligros y riesgos', modulo: 'Peligros y riesgos' },
  { clave: 'peligros_crear', nombre: 'Crear/editar peligros', modulo: 'Peligros y riesgos' },
  { clave: 'peligros_eliminar', nombre: 'Eliminar peligros', modulo: 'Peligros y riesgos' },
  { clave: 'incidentes_ver', nombre: 'Ver incidentes', modulo: 'Incidentes' },
  { clave: 'incidentes_crear', nombre: 'Crear/editar incidentes', modulo: 'Incidentes' },
  { clave: 'inspecciones_ver', nombre: 'Ver inspecciones', modulo: 'Inspecciones' },
  { clave: 'inspecciones_crear', nombre: 'Crear/editar inspecciones', modulo: 'Inspecciones' },
  { clave: 'vigilancia_ver', nombre: 'Ver vigilancia de la salud', modulo: 'Vigilancia' },
  { clave: 'vigilancia_crear', nombre: 'Crear/editar registros', modulo: 'Vigilancia' },
  { clave: 'capacitacion_ver', nombre: 'Ver capacitación', modulo: 'Capacitación' },
  { clave: 'capacitacion_crear', nombre: 'Crear/editar capacitación', modulo: 'Capacitación' },
  { clave: 'epp_ver', nombre: 'Ver EPP', modulo: 'EPP' },
  { clave: 'epp_crear', nombre: 'Crear/editar entregas EPP', modulo: 'EPP' },
  { clave: 'reportes_ver', nombre: 'Ver reportes', modulo: 'Reportes' },
  { clave: 'configuracion_ver', nombre: 'Ver configuración', modulo: 'Configuración' },
  { clave: 'configuracion_usuarios', nombre: 'Gestionar usuarios', modulo: 'Configuración' },
  { clave: 'configuracion_roles', nombre: 'Gestionar roles', modulo: 'Configuración' },
];

export const IDIOMAS = [
  { value: 'es', label: 'Español' },
  { value: 'en', label: 'English' },
  { value: 'pt', label: 'Português' },
];

export const FORMATOS_FECHA = [
  { value: 'DD/MM/YYYY', label: 'DD/MM/AAAA' },
  { value: 'MM/DD/YYYY', label: 'MM/DD/AAAA' },
  { value: 'YYYY-MM-DD', label: 'AAAA-MM-DD' },
];

export const OPCIONES_TEMA = [
  { value: 'claro', label: 'Claro' },
  { value: 'oscuro', label: 'Oscuro' },
  { value: 'sistema', label: 'Según sistema' },
];

/** Tipo de EPP configurable (catálogo). */
export interface TipoEPPConfig {
  codigo: string;
  nombre: string;
}

/** Tipos EPP iniciales para el catálogo. */
export const TIPOS_EPP_INICIALES: TipoEPPConfig[] = [
  { codigo: 'casco', nombre: 'Casco' },
  { codigo: 'gafas', nombre: 'Gafas de seguridad' },
  { codigo: 'guantes', nombre: 'Guantes' },
  { codigo: 'tapabocas', nombre: 'Tapabocas / Respirador' },
  { codigo: 'auditivos', nombre: 'Protección auditiva' },
  { codigo: 'calzado', nombre: 'Calzado de seguridad' },
  { codigo: 'chaleco', nombre: 'Chaleco reflectivo' },
  { codigo: 'arnes', nombre: 'Arnés / Trabajo en alturas' },
  { codigo: 'protector_facial', nombre: 'Protector facial' },
  { codigo: 'overol', nombre: 'Overol / Ropa de trabajo' },
  { codigo: 'otro', nombre: 'Otro' },
];
